module.exports = __webpack_public_path__ + "img/fr_228_btn1.b722cdc9.png";